module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/bonus-pict-fa5c004b0b741a23a44348c32388eee7.jpg";